import React from "react";
import {
    FeedAttachmentLink,
    FeedAttachmentName,
    FeedAttachmentSection,
    FeedSectionLabel
} from "src/components/NoticeboardFeedUi";
import { getAttachmentType } from "../../feedUtils";

const NoticeboardFeedAttachments = ({ attachments }) => {
    if (!Array.isArray(attachments) || !attachments.length) {
        return null;
    }

    return (
        <FeedAttachmentSection aria-label="Post attachments">
            <FeedSectionLabel>Attachments</FeedSectionLabel>
            {attachments.map(attachment => (
                <FeedAttachmentLink
                    key={attachment.uuid}
                    href={attachment.s3Url}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`Open attachment ${attachment.filename}`}
                >
                    <span aria-hidden="true">📎</span>
                    <FeedAttachmentName title={attachment.filename}>{attachment.filename}</FeedAttachmentName>
                    <span>{getAttachmentType(attachment.filename)}</span>
                </FeedAttachmentLink>
            ))}
        </FeedAttachmentSection>
    );
};

export default NoticeboardFeedAttachments;
